module.exports = __webpack_public_path__ + "img/ch80.dfa42be5.png";